import { z } from "zod";

import { TimeReportProject } from "./TimeReportProject";
import { TimeReportProjectSummaryItem } from "./TimeReportProjectSummaryItem";

export const TimeReportProjectSummary = z.object({
  project: TimeReportProject.nullable(),
  items: z.array(TimeReportProjectSummaryItem),
});

export type TimeReportProjectSummary = z.infer<typeof TimeReportProjectSummary>;
